// extracted by mini-css-extract-plugin
export var message = "Message-module--message--84760";